import React from "react";

const Loader = () => {
  return (
    <div className="loading-container">
      <img
        src={
          "https://th.bing.com/th/id/R.5572838d351b66bf6a3350b6d8d23cb8?rik=BS6hh0mN9BmB%2fQ&riu=http%3a%2f%2fwww.invescoeasysteps.ie%2fimg%2floading.gif&ehk=%2f%2fuJgYc%2fYOQ7l0C%2b4vEdW%2bmRA5FlP4Ccv72Tn6RwCqo%3d&risl=&pid=ImgRaw&r=0"
        }
        alt="Loading"
        className="loading-img"
      />
    </div>
  );
};

export default Loader;
